import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { LIST_STATE_STORAGE_KEY } from '../constants';

/** Clears list filters when navigating outside /snapshot-comparison (keeps them for list ↔ detail). */
const useClearSnapshotComparisonListStateOnLeave = () => {
  const history = useHistory();

  useEffect(() => {
    const unlisten = history.listen(location => {
      if (!location.pathname.startsWith('/snapshot-comparison')) {
        sessionStorage.removeItem(LIST_STATE_STORAGE_KEY);
      }
    });

    return unlisten;
  }, [history]);
};

export default useClearSnapshotComparisonListStateOnLeave;
